import React, { useState } from "react";
import { Button, Input } from "antd";
import "../auth-common.css";
import "./set_password.css";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { SuccessToast } from "../../widgets/AppToast";
import { post } from "../../services/services";
import { ApiURL } from "../../services/apiConstants";

const SetPassword = () => {
  const navigate = useNavigate();
  const { token, email } = useParams();
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});

  // Set Password API
  const addPassword = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("new_password", password);
    formData.append("confirm_password", passwordConfirmation);
    formData.append("email", atob(email));
    formData.append("token", token);
    try {
      const res = await post(ApiURL.password_reset, formData);
      if (res?.status === true) {
        SuccessToast("Success!!", "Set Password Successfully");
        navigate("/");
      } else {
        setErrors(res?.errors || {});
      }
    } catch (error) {
      setErrors({ catch: ["An error occurred. Please try again."] });
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-glass-card">
        <div className="auth-header">
          <h5>MarinBytes - Data, Ships, People and Sustainability</h5>
          <h2>Set New Password</h2>
        </div>
        <div className="auth-body">
          {errors?.try && <span style={{ color: "red", display: 'block', marginBottom: '10px' }}>{errors.try[0]}</span>}
          {errors?.catch && <span style={{ color: "red", display: 'block', marginBottom: '10px' }}>{errors.catch[0]}</span>}
          
          <div className="auth-input-group">
            <label>New Password</label>
            <Input.Password
              size="large"
              placeholder="Enter new password"
              onChange={(e) => setPassword(e.target.value)}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
            {errors?.new_password && <span style={{ color: "red", fontSize: '12px' }}>{errors.new_password}</span>}
          </div>

          <div className="auth-input-group">
            <label>Confirm New Password</label>
            <Input.Password
              size="large"
              placeholder="Confirm your password"
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
            {errors?.confirm_password && (
              <span style={{ color: "red", fontSize: '12px' }}>{errors.confirm_password}</span>
            )}
            {errors?.password && <span style={{ color: "red", fontSize: '12px' }}>{errors.password}</span>}
          </div>

          <Button 
            className="auth-primary-btn" 
            type="primary" 
            onClick={addPassword} 
            loading={loader}
          >
            Update Password
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
